import i18n from '@service/I18nService';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { realtorSearchConstants, realtorSearchModels } from '..';

export const useSearchKeySearch = (props?: { search?: string; lang?: string; isNumber?: boolean }) =>
  useQuery<realtorSearchModels.ISearch[]>({
    queryKey: [realtorSearchConstants.queryKeys.SEARCH_KEY_SEARCH, props],
    queryFn: async () => {
      const res = await $api.post('/v1/search-key/search', {
        isNumber: props?.search ? !!Number(props?.search.replace(/\s/g, '')) : false,
        lang: i18n.language?.toUpperCase(),
        ...props
      });

      return res.data.data;
    }
  });
